import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '../services/login/login.service';
import { map } from 'rxjs';

export const loginGuard: CanActivateFn = (route, state) => {

  const service = inject(LoginService);
  const router = inject(Router);

  if (!service.isAuthenticatedUser()) {
    return true
  }
  router.navigate(['company-information'])
  return false
};
